var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqualsOutline16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74414 5C2.32993 5 1.99414 5.33579 1.99414 5.75C1.99414 6.16421 2.32993 6.5 2.74414 6.5H13.2495C13.6638 6.5 13.9995 6.16421 13.9995 5.75C13.9995 5.33579 13.6638 5 13.2495 5H2.74414ZM2.74414 9.5C2.32993 9.5 1.99414 9.83579 1.99414 10.25C1.99414 10.6642 2.32993 11 2.74414 11H13.2495C13.6638 11 13.9995 10.6642 13.9995 10.25C13.9995 9.83579 13.6638 9.5 13.2495 9.5H2.74414Z",
    fill: "#7B868C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualsOutline16);
export default __webpack_public_path__ + "static/media/equals_outline_16.cf91c755369cf5976c46b43d9a848375.svg";
export { ForwardRef as ReactComponent };